(function() {
    'use strict';

    angular.module("imApp").factory("biReportsService", ['$ihttp', function ($ihttp) {
        let service = {
            listBiReports: function (parms) {
                return $ihttp.post({
                    method: 2660,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
